<template>
    <div class="content-wrapper">
        <app-breadcrumb :page-title="$t('settings')" :directory="$t('settings')" :icon="'settings'"/>
        <app-tab :tabs="tabs" :icon="tabIcon"/>
    </div>
</template>

<script>

    import {FormMixin} from "../../../../core/mixins/form/FormMixin";

    export default {
        name: "Setting",
        mixins: [FormMixin],

        data() {
            return {

                loggedInUser: {},
                tabIcon: 'settings',
                tabs: [
                    {
                        'name': this.$t('general'),
                        'title': this.$t('general'),
                        'component': 'app-general-settings',
                        'permission': ''
                    },
                    {
                        'name': this.$t('museums'),
                        'title': this.$t('museums'),
                        'component': 'app-museum-settings',
                        'permission': ''
                    },
                    // {
                    //     'name': this.$t('custom_fields'),
                    //     'title': this.$t('custom_fields'),
                    //     'component': 'app-custom-field',
                    //     'permission': '',
                    //     headerButton: {
                    //         label: this.$t('add_custom_field'),
                    //         class: 'btn btn-primary'
                    //     }
                    // },
                    {
                        'name': this.$t('email_setup'),
                        'title': this.$t('email_setup'),
                        'component': 'app-email-setup',
                        'permission': ''
                    },
                  {
                    'name': this.$t('notification'),
                    'title': this.$t('notification'),
                    'component': 'app-notification-settings',
                    'permission': ''
                  },
                 

                ],
            }
        },

    }
</script>
